import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SearchSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2 10.0162C2 14.4914 5.63956 18.1219 10.1148 18.1219C11.9114 18.1219 13.5591 17.5367 14.9021 16.5405L20.1267 21.7783C20.3419 21.9884 20.6227 22.0946 20.9168 22.0946C21.5575 22.0946 22 21.6095 22 20.9892C22 20.6942 21.8838 20.4264 21.6969 20.2172L16.4903 15.0016C17.5746 13.6274 18.2165 11.9007 18.2165 10.0162C18.2165 5.54494 14.586 1.9054 10.1148 1.9054C5.63956 1.9054 2 5.54494 2 10.0162ZM3.54895 10.0162C3.54895 6.39317 6.48776 3.45436 10.1148 3.45436C13.7287 3.45436 16.6766 6.39317 16.6766 10.0162C16.6766 13.6341 13.7287 16.582 10.1148 16.582C6.48776 16.582 3.54895 13.6341 3.54895 10.0162Z"
        fill={color}
      />
    </svg>
  );
};

export { SearchSvg };
